import styled, { css } from 'styled-components';
export const Container = styled.div ``;
export const RadioInput = styled.input `
  ${({ theme }) => css `
    display: flex;
    align-items: center;
    justify-content: center;
    appearance: none;
    width: 24px;
    height: 24px;
    border: 2px solid ${theme.color.brand.primary.nth1};
    border-radius: 50%;
    background: transparent;
    transition: background 0.5s;
    outline: none;
    cursor: pointer;
    &:before {
      content: '';
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: ${theme.color.brand.primary.nth1};
      transition: opacity 0.5s;
      opacity: 0;
    }
    &:checked {
      &:before {
        opacity: 1;
      }
    }
  `}
`;
//# sourceMappingURL=RadioButton.styles.js.map